module.exports = __webpack_public_path__ + "6699a8c8b89d2943ffb491545f941496.pdf";